import troubles from './troubles.html';

export default angular.module('bfunc.FormControls', [])
	.run(['$rootScope','$templateCache',($rootScope, $templateCache)=>{

		let templates = {
			troubles: troubles
		};
		angular.forEach(templates, (tpl, name)=>{
			$templateCache.put(name+'.tpl', tpl);
		});
	}])
	.name;





/** WEBPACK FOOTER **
 ** ./src/components/formControls/index.js
 **/